// extracted by mini-css-extract-plugin
export default {"root":"remindPassForm__root__snHEV","input":"remindPassForm__input__hgsdj","hint":"remindPassForm__hint__ZdpId"};